import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Constant} from '../../global/util/Constant';
import {Observable} from 'rxjs';
import {DesignEmailTemplate} from '../model/DesignEmailTemplate';
import {Headers} from '../../global/util/Headers';

@Injectable({
    providedIn: 'root'
})
export class DesignEmailTemplateService {
    private url = Constant.ROOT_API_V1;

    constructor(private http: HttpClient) {
    }

    register(designEmailBody: DesignEmailTemplate): Observable<any> {
        return this.http.post(this.url.concat('/design-email-template/save'), JSON.stringify(designEmailBody), Headers.contentType);
    }

    getBy(workflowId: number, alertType: number): Observable<any> {
        return this.http.get(this.url.concat('/design-email-template/').concat(String(workflowId)).concat('/workflow/').concat(String(alertType)).concat('/template'));
    }
}
